import { isRescheduleWindowOpen } from '@src/domains/sale-items/core/isRescheduleWindowOpen';

export const RescheduleNotice = {
  Available: 'available',
  DeadlineExpired: 'deadline-expired',
  NotReschedulable: 'not-reschedulable',
  None: 'none',
} as const;

export type RescheduleNotice = (typeof RescheduleNotice)[keyof typeof RescheduleNotice];

interface Params {
  allowsRescheduling: boolean;
  canReschedule: boolean;
  rescheduleUntil: string | null;
  remainingRescheduleCount: number;
  now?: Date;
}

export function resolveRescheduleNotice(params: Params): RescheduleNotice {
  const { allowsRescheduling, canReschedule, rescheduleUntil, remainingRescheduleCount, now } = params;

  if (!allowsRescheduling) {
    return RescheduleNotice.NotReschedulable;
  }

  if (!isRescheduleWindowOpen(rescheduleUntil, now)) {
    return RescheduleNotice.DeadlineExpired;
  }

  if (canReschedule && remainingRescheduleCount > 0) {
    return RescheduleNotice.Available;
  }

  return RescheduleNotice.None;
}
